/* eslint-disable no-sequences */
import axios from "axios";
import { apiUrl_forCart } from "./constants";
import { apiUrl_forOrders } from "./constants";

const CancelToken = axios.CancelToken;

export let cancelGetOrdersApi;
export async function getOders(headers, query = "") {
    if (headers) {
        const orders = await axios.get(apiUrl_forOrders + "?" + query, {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetOrdersApi = c;
            }),
        });
        return orders;
    } else {
        console.log("Please add required parameters");
    }
}

export let cancelAddCartApi;
export async function createOrder(headers, orderData) {
    if ((headers && orderData)) {
        const order = await axios.post(
            apiUrl_forCart + "create/order",
            orderData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddCartApi = c;
                }),
            }
        );
        return order;
    } else {
        console.log("Please add required parameters");
    }
}

// get order details
export let cancelGetOrderDetailsApi;
export async function getOrderDetails(headers, orderId) {
    if (headers && orderId) {
        const ordersData = await axios.get(
            apiUrl_forOrders + `detail/${orderId}`,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetOrderDetailsApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// get order notes
export let cancelGetOrderNotesApi;
export async function getOrderNotes(headers, orderId) {
    if (headers && orderId) {
        const ordersData = await axios.get(
            apiUrl_forOrders + `notes/${orderId}`,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetOrderNotesApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// add order notes
export let cancelAddOrderNotesApi;
export async function addOrderNotes(headers, { orderId, notes }) {
    if (headers && orderId && notes) {
        const ordersData = await axios.post(
            apiUrl_forOrders + `notes/${orderId}`,
            { notes },
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddOrderNotesApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// update order notes
export let cancelUpdateOrderNotesApi;
export async function updateOrderNotes(headers, { orderId, notes }) {
    if (headers && orderId && notes) {
        const ordersData = await axios.put(
            apiUrl_forOrders + `notes/${orderId}`,
            { notes },
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateOrderNotesApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// add order notes
export let cancelDeleteOrderNotesApi;
export async function deleteOrderNotes(headers, { orderId, noteId }) {
    if (headers && orderId && noteId) {
        const ordersData = await axios.delete(
            apiUrl_forOrders + `notes/${orderId}/${noteId}`,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteOrderNotesApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// order status list
export let cancelGetOrderStatusListApi;
export async function getOrderStatusList(headers) {
    if (headers) {
        const orders = await axios.get(apiUrl_forOrders + "statuses", {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetOrderStatusListApi = c;
            }),
        });
        return orders;
    } else {
        console.log("Please add required parameters");
    }
}

// order status list
export let cancelGetOrderPaymentStatusListApi;
export async function getOrderPaymentStatusList(headers) {
    if (headers) {
        const orders = await axios.get(apiUrl_forOrders + "payment/statuses", {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetOrderPaymentStatusListApi = c;
            }),
        });
        return orders;
    } else {
        console.log("Please add required parameters");
    }
}

// update order status
export let cancelUpdateOrderStatusApi;
export async function updateOrderStatus(
    headers,
    { orderId, statusCode, trackingNumber }
) {
    if (headers && orderId && statusCode) {
        const ordersData = await axios.put(
            apiUrl_forOrders + `status/${orderId}`,
            {
                status_code: statusCode,
                tracking_number: trackingNumber,
            },
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateOrderStatusApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// update order status
export let cancelUpdatePaymentStatusApi;
export async function updatePaymentStatus(headers, { orderId, statusCode }) {
    if (headers && orderId && statusCode) {
        const ordersData = await axios.put(
            apiUrl_forOrders + `payment/status/${orderId}`,
            { status_code: statusCode },
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdatePaymentStatusApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}
